export default __webpack_public_path__ + "static/media/tariq.6747ae0a.jpg";